import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import Plx from 'react-plx';
import {
  SectionName, buildPlxData,
} from '../common/styles';
import {
  BaseContainer, BaseDesc, BaseTitle,
} from './styles';

const Container = styled.div`
  width: 100vw;
  max-width: 100vw;
  margin: auto;
  ${props => (props.theme.isMobile ? `
    background-image: url(${props.theme.linearGradientMobileImage});
    background-size: cover;
    background-position: center;
  ` : `
    background: linear-gradient(-100.09deg, rgba(253, 255, 255, 0.5) 47.62%, rgba(255, 255, 255, 0.5) 54.33%, rgba(144, 237, 255, 0.5) 122.74%), linear-gradient(100.09deg, rgba(253, 255, 255, 0.5) 47.62%, rgba(255, 255, 255, 0.5) 54.33%, rgba(144, 237, 255, 0.5) 122.74%);
  `)};
`;

const InnerContainer = styled(BaseContainer)`
  margin-top: ${props => (props.theme.isMobile ? '32px' : '60px')};
  margin-bottom: ${props => (props.theme.isMobile ? '32px' : '60px')};
  flex-direction: ${props => (props.theme.isMobile ? 'column-reverse' : 'row')};
`;

const Image = styled(Img)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    max-width: 560px;
    width: 44vw;
  `)};
`;

const SectionNameExt = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
`;

const BaseDescExt = styled(BaseDesc)`
  a {
    color: #1E58CF;
    text-decoration: underline;
  }
`;

export default function SophisticatedInvestors() {
  const { sophisticatedInvestorsImage, isMobile } = React.useContext(ThemeContext);
  const plxData = buildPlxData('#sophisticated_investors', 0);

  return (
    <Container id="sophisticated_investors">
      <InnerContainer>
        <Plx className="left-section" parallaxData={plxData.image} disabled={isMobile}>
          <Image src={sophisticatedInvestorsImage} />
        </Plx>
        <Plx className="base-section" parallaxData={plxData.text} disabled={isMobile}>
          <SectionNameExt>Quality Retail Audience</SectionNameExt>
          <BaseTitle>Sophisticated and affluent</BaseTitle>
          <BaseDescExt>
            Our sophisticated investors have large and diversified portfolios across a
            range of investment types, including managed funds, LICs, ETFs, and Australian
            and global equities.
          </BaseDescExt>
        </Plx>
      </InnerContainer>
    </Container>
  );
}
